import axios from "axios";

import { setCarrierSettingPopup, setTerm } from "../actions/user";
import { api } from "../config/variables";
import store from "../store/storeInstance";
import { readCookie } from "../utils/functions";

export const axiosInstance = axios.create({
	baseURL: api.baseURL + api.restApiRoot,
	headers: {
		"Content-Type": "application/json;charset=UTF-8",
	},
	crossDomain: true,
	withCredentials: true,
});

export const axiosRegistration = axios.create({
	baseURL: api.baseURL,
	headers: {
		"Content-Type": "application/json;charset=UTF-8",
	},
	crossDomain: true,
	withCredentials: true,
});

export const axiosRatingInstance = axios.create({
	baseURL:
		api.other_services.rating.baseURL + api.other_services.rating.restApiRoot,
});

export const axiosFastApiInstance = axios.create({
	baseURL: api.fast_api,
	crossDomain: true,
	headers: {
		"Content-Type": "application/json;charset=UTF-8",
	},
	withCredentials: true,
});

axiosFastApiInstance.interceptors.request.use(
	(config) => {
		const bearerToken = readCookie("bearer");
		if (bearerToken) {
			return {
				...config,
				headers: {
					...config.headers,
					Authorization: `bearer ${bearerToken}`,
				},
			};
		}
		return config;
	},
	(error) => Promise.reject(error)
);

export const axiosShipRocketInstance = axios.create({
	baseURL: api.shiprocket + api.shiprocket_version,
	crossDomain: true,
	headers: {
		"Content-Type": "application/json;charset=UTF-8",
	},
});

axiosShipRocketInstance.interceptors.request.use(
	(config) => {
		const bearerToken = readCookie("bearer");
		if (bearerToken) {
			return {
				...config,
				headers: {
					...config.headers,
					Authorization: `bearer ${bearerToken}`,
				},
			};
		}
		return config;
	},
	(error) => Promise.reject(error)
);

export const axiosShipRocketKycInstance = axios.create({
	baseURL: api.shiprocketKyc + api.shiprocket_version,
	crossDomain: true,
	headers: {
		"Content-Type": "application/json;charset=UTF-8",
	},
});

axiosShipRocketKycInstance.interceptors.request.use(
	(config) => {
		const bearerToken = readCookie("bearer");
		if (bearerToken) {
			return {
				...config,
				headers: {
					...config.headers,
					Authorization: `bearer ${bearerToken}`,
				},
			};
		}
		return config;
	},
	(error) => Promise.reject(error)
);

axiosInstance.interceptors.request.use(
	(config) => {
		const token = readCookie("bearer");
		if (token) {
			return {
				...config,
				headers: {
					...config.headers,
					Authorization: `token ${token}`,
				},
			};
		}
		return config;
	},
	(err) => Promise.reject(err)
);

axiosInstance.interceptors.response.use(
	(response) => {
		store.dispatch(
			setTerm({
				maintenance_popup: false,
			})
		);
		return response;
	},
	(err) => {
		if (err?.response?.status > 500) {
			store.dispatch(
				setTerm({
					maintenance_popup: true,
				})
			);
		}
		return Promise.reject(err);
	}
);

axiosInstance.interceptors.response.use(
	(response) => {
		store.dispatch(
			setTerm({
				agreement_popup: false,
			})
		);

		return response;
	},
	(err) => {
		if (
			err?.response?.status === 403 &&
			err?.response?.data?.detail ===
				"Please accept agreement terms to proceed further"
		) {
			store.dispatch(
				setTerm({
					agreement_popup: true,
					agreement_popup_data: err.response.data,
				})
			);
			return Promise.reject(err || new Error("Agreement terms required"));
		}
		if (
			err?.response?.status === 403 &&
			err?.response?.data?.detail === "Auto Assign Carrier is required"
		) {
			localStorage.setItem("client_id", err?.response?.data?.client_id);
			store.dispatch(
				setCarrierSettingPopup({
					carrier_setting_required: true,
				})
			);

			return Promise.reject(
				err || new Error("Auto Assign Carrier is required")
			);
		}
		const err_obj = { url: err?.response?.request?.responseURL, error: err };
		if (!err_obj?.url?.includes("add-logs")) {
			// Pass axiosInstance directly to avoid circular dependency
			// This way logger.js doesn't need to import apiInstance.js
			import("./logger").then(({ generateLogger }) => {
				const loggerThunk = generateLogger(err_obj, undefined, axiosInstance);
				store.dispatch(loggerThunk);
			});
		}
		return Promise.reject(err);
	}
);

axiosRatingInstance.interceptors.request.use(
	(config) => {
		const token = readCookie("bearer");
		if (token) {
			return {
				...config,
				headers: {
					...config.headers,
					"Content-Type": "application/json",
					Authorization: `token ${token}`,
				},
			};
		}
		return {
			...config,
			headers: {
				...config.headers,
				"Content-Type": "application/json",
			},
		};
	},
	(err) => Promise.reject(err)
);
